var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import getQuotingEnginePrice from '@shared/utils/frontend/pricing/get-quoting-engine-price';
import { useSession } from '@/contexts/LitSessionProvider';
export function useEnginePrice() {
    var _this = this;
    var _a;
    var PKP = useSession().PKP;
    var _b = useState({
        cloudWallet: null,
        solanaAddress: (PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress) || null,
        tokensIn: [],
        tokensOut: [],
        fromSlippage: 0,
        toSlippage: 0,
        fromGasMultiplier: 1,
        toGasMultiplier: 1,
        permitBatchDetails: [],
        permitSignatures: [],
        publicKeys: {
            payer: '',
            feePayer: '',
        },
        refreshToken: '',
    }), params = _b[0], setParams = _b[1];
    var cloudWallet = params.cloudWallet, solanaAddress = params.solanaAddress, tokensIn = params.tokensIn, tokensOut = params.tokensOut, fromSlippage = params.fromSlippage, toSlippage = params.toSlippage, permitBatchDetails = params.permitBatchDetails, permitSignatures = params.permitSignatures;
    var handleSetParams = function (key, value) {
        setParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[key] = value, _a));
        });
    };
    var enabled = function () {
        if (!cloudWallet) {
            var enabledError = 'No cloud wallet';
            return {
                enabled: false,
                error: enabledError,
            };
        }
        if (!tokensIn.length) {
            var enabledError = 'No tokens in';
            return {
                enabled: false,
                error: enabledError,
            };
        }
        if (tokensIn.some(function (token) { return !token.amount || token.amount === '0'; })) {
            var enabledError = 'No token amount';
            return {
                enabled: false,
                error: enabledError,
            };
        }
        if (!tokensOut.length) {
            var enabledError = 'No tokens out';
            return {
                enabled: false,
                error: enabledError,
            };
        }
        if (!fromSlippage) {
            var enabledError = 'No from slippage';
            return {
                enabled: false,
                error: enabledError,
            };
        }
        return {
            enabled: true,
            error: '',
        };
    };
    var query = useQuery({
        queryKey: ['enginePrice', params],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getQuotingEnginePrice({
                            cloudWallet: cloudWallet,
                            solanaAddress: solanaAddress,
                            tokensIn: tokensIn,
                            tokensOut: tokensOut,
                            fromSlippage: fromSlippage,
                            toSlippage: toSlippage,
                            permitBatchDetails: permitBatchDetails,
                            permitSignatures: permitSignatures,
                            baseUrl: '/api/wrapper?target=',
                            PKP: __assign({}, PKP),
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: (_a = enabled()) === null || _a === void 0 ? void 0 : _a.enabled,
    });
    return __assign(__assign({}, query), { setParams: setParams, handleSetParams: handleSetParams, params: params });
}
